import { DialogActions, DialogContent } from "@mui/material";
import {
  Button,
  Checkbox,
  Field,
  FieldsContainer,
  Form,
  PageHeader,
  TextField,
} from "common";
import { ParamsContext } from "common/components/Form/ParamsContext";
import I18n from "i18n";
import useCouponForm, { UseCouponFormProps } from "./useCouponForm";

export interface CouponFormProps extends UseCouponFormProps {}

export default function CouponForm({
  id,
  afterSave,
  onClose,
  defaultValues,
}: CouponFormProps) {
  const form = useCouponForm({ id, afterSave, defaultValues });
  const {
    item,
    options,
    errors,
    loading,
    isDirty,
    isCreate,
    getIsDirty,
    getRequiredFields,
    onChange,
    save,
    saving,
  } = form;
  const title = isCreate ? I18n.t("Coupon.addTitle") : item.code;

  return (
    <ParamsContext.Provider value={{ coupon_id: id }}>
      <PageHeader title={title} onClose={onClose} loading={loading} />
      <DialogContent>
        <Form
          loading={loading}
          item={item}
          options={options}
          errors={errors}
          onChange={onChange}
          translationCategory="Coupon.attributes"
          isDirty={getIsDirty}
          requiredFields={getRequiredFields()}
        >
          <FieldsContainer>
            <Field fullWidth>
              <TextField id="code" />
            </Field>
            <Field fullWidth>
              <TextField
                id="discount_percent"
                mask={Number}
                numberOptions={{ scale: 0, min: 0 }}
              />
            </Field>
            <Field fullWidth>
              <Checkbox id="active" />
            </Field>
          </FieldsContainer>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button
          title={I18n.t("App.save")}
          disabled={!isDirty}
          onClick={() => save()}
          loading={saving}
        />
      </DialogActions>
    </ParamsContext.Provider>
  );
}
